module.exports = __webpack_public_path__ + "static/img/inr-payment-image.d6c697aa.svg";